export default __webpack_public_path__ + "uusiSuomi_logo.svg";